import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, map, mergeMap, Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals';
import { SideNavbarService } from 'src/app/side-navbar/side-navbar.service';
import { EducationService } from '../education.service';
import { TextService } from '../../shared/text.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'educations-by-education-type-and-organisation',
  templateUrl: './educations-by-education-type-and-organisation.component.html',
  styleUrls: ['./educations-by-education-type-and-organisation.component.css']
})
export class EducationsByEducationTypeAndOrganisationComponent implements OnInit {

  @Input('education-type-id') educationTypeId!: any;
  @Input('organisation-unit-id') organisationUnitId!: any;
  @Input('period') period!: any;
  //period: any;
  id: any;
  units: any;
  isLoaded = false;
  //@Output() educationsLoaded = false;
  header!: any;
  educations!: any;
  educationType!: any;
  panelOpenState = false;
  private subscription: Subscription = new Subscription();

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private navigationService: SideNavbarService,
    private textService: TextService,
    private educationService: EducationService,
    private titleService: Title
  ) {
    //tämä ilmeisesti estää koulutusten latautumisen back-painalluksen yhteydessä?
    route.params.subscribe(params => {

      this.subscription.unsubscribe();
      this.subscription = new Subscription();
      this.ngOnInit();
    })
    /*this.subscription.add(this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
        if (e instanceof NavigationEnd) {
          console.log('haetaan uusiksi');
          this.getEducations();
        }
      }));*/
   }

  ngOnInit(): void {
    // tällä saadaan aikaan latauspalkki
    this.subscription.add(this.route.url.subscribe(url => {
      this.isLoaded = false;
    }));
    
    this.subscription.add(this.textService.getText('educations').subscribe(
      value => this.header = value
    ));
    /*this.subscription.add(
        this.educationService.getEducationsByEducationTypeAndOrganisation(this.organisationUnitId, this.educationTypeId).subscribe(educations => {
          this.educations = educations;
          this.globals.sortByName2(educations, this.globals.lang);
          this.educations.forEach((education: { children: any[]; }) => {
            this.globals.sortByName2(education.children, this.globals.lang);
          })
        })
      );*/

      this.getEducations();
      
      /*this.subscription.add(this.route.params.subscribe(params => {
        if (params['lang'] === 'fi') {
          this.globals.lang = 'fi'
        }
        if (params['lang'] === 'en') {
          this.globals.lang = 'en'
        }
        if (params['lang'] === 'sv') {
          this.globals.lang = 'sv'
        }
      }));*/
      //this.subscription.add(this.globals.setLangFromRoute(this.route));
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getEducations() {
    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        educationTypeIdId: params[0].get('education-type-id'),
        organisationId: params[0].get('organisation-unit-id'), 
        period: params[1].get('period')
      })),
      // haetaan aliorganisaatiot
      mergeMap(params => {
        this.organisationUnitId = params.organisationId;
        this.educationTypeId = params.educationTypeIdId
        this.period = params.period;
        //this.setCurrentUrl();
        return this.educationService.getEducationsByEducationTypeAndOrganisation(this.organisationUnitId, this.educationTypeId);
      }),
      //})).subscribe(
      mergeMap(educations => {
          this.educations = educations;
          this.globals.sortByName2(educations, this.globals.lang);
          this.educations.forEach((education: { children: any[]; }) => {
            this.globals.sortByName2(education.children, this.globals.lang);
          })
          return this.navigationService.getNavigationItem(this.educationTypeId);
      })).subscribe(navigationItem => {
        this.educationType = navigationItem;
        //this.setTitle();
        //this.setCurrentUrl();
        this.isLoaded = true;
        
      }
      ));
  }

  /*ngDoCheck(): void{
    console.log('EMITTI')
    this.educationsLoaded.emit("true");
  }*/

  /**
     * Päätellääm koulutus kaksiportaiseksi, jos se sisältää ainakin yhden 
     * BA-tasoisen ja ainakin yhden muu-tasoisen tutkinnon.
     * @param units 
     */
   isTwoCycleDegree(units: any[]) {
      
    let bachelor = false;
    let other = false;
    units.forEach(unit => {
      if (unit.educationLevel != null) {
        if(unit.educationLevel == 'BA') {
          bachelor = true;
        } else {
          other = true;
        }
      }
    });
    //console.log(bachelor);
    return bachelor && other;
  }

  /*setTitle() {
    if (this.period) {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.educationType.name) + ' | ' + this.globals.getLocalizedValue(this.header) + environment.titleExtension + ' ' + this.period);
    } else {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.educationType.name) + environment.titleExtension);
    }
  }

  setCurrentUrl() {
    
      if (!this.period) {
        this.globals.currentUrl = {
          valueFi:'/fi/' + this.globals.toKebabCase(this.educationType.name.valueFi) + '/' + this.educationType.id, 
          valueEn:'/en/' + this.globals.toKebabCase(this.educationType.name.valueEn) + '/' + this.educationType.id, 
          valueSv:'/sv/' + this.globals.toKebabCase(this.educationType.name.valueSv) + '/' + this.educationType.id
        };
      } else {           
        this.globals.currentUrl = {
          valueFi:'/fi/' + this.globals.toKebabCase(this.educationType.name.valueFi) + '/' + this.educationType.id + '?period=' + this.period, 
          valueEn:'/en/' + this.globals.toKebabCase(this.educationType.name.valueEn) + '/' + this.educationType.id + '?period=' + this.period, 
          valueSv:'/sv/' + this.globals.toKebabCase(this.educationType.name.valueSv) + '/' + this.educationType.id + '?period=' + this.period
        }
      }
    //this.globals.createLinkForCanonicalURL();
  } //end of setCurrentUrl()
*/

}
